import fs from 'node:fs'
import path from 'node:path'

/**
 * Vercel CLI v54 writes to `.env.local` on its own with no opt-out: `vercel link` injects
 * `VERCEL_OIDC_TOKEN` (creating the file when missing) via its post-link OIDC refresh, and
 * `vercel blob create-store` runs a full `env pull` over the file after connecting the store.
 */
export function guardEnvLocal(cwd: string): { restore: () => void } {
  const envPath = path.join(cwd, '.env.local')
  let original: string | undefined
  try {
    original = fs.readFileSync(envPath, 'utf-8')
  } catch {
    original = undefined
  }

  return {
    restore(): void {
      try {
        const current = fs.existsSync(envPath) ? fs.readFileSync(envPath, 'utf-8') : undefined
        if (current === original) return
        if (original === undefined) {
          fs.rmSync(envPath, { force: true })
        } else {
          fs.writeFileSync(envPath, original)
        }
      } catch {}
    }
  }
}
